(function () {
  'use strict'

  /**
     * @ngdoc directive
     * @name ThismomentErrSrc
     * @module thismoment.common.directive.errSrc
     *
     * @param {scope} scope
     * @param {Element} element the html element to bind the error message to
     * @param {object} attrs an object of attributes for the html element
     *
     * @description
     * A directive that shows which element is causing an error
     */

  const MODULE_NAME = 'thismoment.common.directive.errSrc'

  require('angular')
    .module(MODULE_NAME, [])
    .directive('errSrc', errSrc)
    .directive('errSrcFunc', errSrcFunc)

  function errSrc () {
    return {
      link: function (scope, element, attrs) {
        element.bind('error', function () {
          if (attrs.src !== attrs.errSrc) {
            attrs.$set('src', attrs.errSrc)
          }
        })
      }
    }
  }

  function errSrcFunc () {
    return {
      scope: {
        errSrcFunc: '&errSrcFunc'
      },
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('error', function () {
          if (angular.isFunction(scope.errSrcFunc)) {
            scope.errSrcFunc()
          }
        })
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/directive/err-src.js